/**
 * Lucide icon map keyed by `BusinessTypeKey`.
 *
 * The backend's `BUSINESS_TYPE_META[key].icon` returns the lucide component
 * NAME (e.g. "Sparkles"). We resolve it to the actual component here so
 * components stay typed and tree-shaking works.
 */
import {
  Building2,
  Briefcase,
  Coffee,
  Croissant,
  Dumbbell,
  GraduationCap,
  IceCream,
  Scissors,
  ShoppingBag,
  Sparkles,
  Stethoscope,
  UtensilsCrossed,
  Wrench,
  type LucideIcon,
} from "lucide-react";
import type { BusinessTypeKey } from "../../api/types";

export const INDUSTRY_ICONS: Record<BusinessTypeKey, LucideIcon> = {
  spa: Sparkles,
  salon: Scissors,
  gym: Dumbbell,
  ice_cream: IceCream,
  cafe: Coffee,
  bakery: Croissant,
  restaurant: UtensilsCrossed,
  retail: ShoppingBag,
  consulting: Briefcase,
  tutoring: GraduationCap,
  repair: Wrench,
  clinic: Stethoscope,
  general: Building2,
};
